export type StatsChangeTone = "up" | "down" | "flat";

export interface StatsChange {
    // Со знаком: минус означает падение.
    percent: number;
    tone: StatsChangeTone;
}

/*
* Изменение относительно периода сравнения. Сравнивать не с чем, когда за прошлый период не
* было заказов: прежний экран показывал в этом случае «+100 %», хотя рост считать не от чего.
* Пустой результат интерфейс показывает прочерком.
* */
export const compareChange = (current: number, previous: number): StatsChange | null => {
    if (previous <= 0) return null;

    const percent = ((current - previous) / previous) * 100;

    // Округляем до той же десятой, что и подпись: иначе «+0,0 %» приезжало бы зелёным как рост.
    const rounded = Number(percent.toFixed(1));

    return { percent, tone: rounded === 0 ? "flat" : rounded > 0 ? "up" : "down" };
};

export const formatChange = (change: StatsChange): string => {
    const value = Math.abs(change.percent).toFixed(1);

    if (change.tone === "flat") return `${value} %`;

    return `${change.tone === "up" ? "+" : "−"}${value} %`;
};
